import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { msal } from './autenticacion'
import { msalDePlataforma } from './autenticacionPlataforma'
import { mantenerCuentaActiva } from './cuentaActiva'
import { App } from './App'
import { ConsolaDePlataforma } from './paginas/plataforma/ConsolaDePlataforma'
import './estilos.css'

// RF-107: la consola interna de plataforma vive en su propia subruta, con su propia instancia
// de MSAL (autenticacionPlataforma) — nunca la misma sesión que el resto de la SPA de
// despachos. Solo una de las dos se inicializa y se monta por carga de página.
const esConsolaDePlataforma = window.location.pathname.startsWith('/plataforma')
const instanciaMsal = esConsolaDePlataforma ? msalDePlataforma : msal

// MSAL debe inicializarse antes de montar la aplicación.
instanciaMsal.initialize().then(() => {
  mantenerCuentaActiva(instanciaMsal)

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={instanciaMsal}>
        {esConsolaDePlataforma ? <ConsolaDePlataforma /> : <App />}
      </MsalProvider>
    </React.StrictMode>,
  )
})
